import React, { useState } from "react";


const DocumentPreview = ({ files, getFilePreview, handleFileDelete }) => {
    const [heicPreview, setHeicPreview] = useState({})

    const isImage = (file) => file && file.type.includes("image")
    const isPdf = (file) => file && file.type.includes("pdf")
    const isHeic = (file) => file && (file.type === "image/heic" || file.name.toLowerCase().endsWith(".heic"))

    const convertHeic = async (file, index) => {
        if (heicPreview[index]) return;
        try {
            const heic2any = (await import("heic2any")).default;
            const blob = await heic2any({
                blob: file,
                toType: "image/jpeg",
                quality: 0.8,
            });

            const jpegUrl = URL.createObjectURL(blob);
            setHeicPreview((prev) => ({ ...prev, [index]: jpegUrl }));
        } catch (error) {
            console.error("HEIC conversion failed:", error);
        }
    };

    return (
        <ul className="file-list">
            {files &&
                files.length > 0 &&
                files.map((file, index) => {
                    if (isHeic(file)) {
                        convertHeic(file, index);
                        return (
                            <li key={index} className="file-item">
                                {heicPreview[index] ? (
                                    <img src={heicPreview[index]} alt={file.name} className="file-preview" />) : (<div style={{ padding: 20 }}>Loading...</div>)}

                                <p className="file-name-delete">
                                    <span className="file-name">{file.name}</span>
                                    <span className="delete-icon" onClick={() => handleFileDelete(index)}                                    >
                                        <i className="fa fa-trash" /> Remove
                                    </span>
                                </p>
                            </li>
                        );
                    }

                    if (isImage(file)) {
                        return (
                            <li key={index} className="file-item">
                                <img src={getFilePreview(file)} alt={file.name} className="file-preview" />

                                <p className="file-name-delete">
                                    <span className="file-name">{file.name}</span>
                                    <span className="delete-icon" onClick={() => handleFileDelete(index)}                                    >
                                        <i className="fa fa-trash" /> Remove
                                    </span>
                                </p>
                            </li>
                        );
                    }

                    if (isPdf(file)) {
                        return (
                            <li key={index} className="file-item">
                                <div style={{ width: "100%", height: "400px", overflow: "hidden" }}>
                                    <embed src={getFilePreview(file)} width="100%" height="100%" type="application/pdf" />
                                </div>

                                <p className="file-name-delete">
                                    <span className="file-name">{file.name}</span>
                                    <span
                                        className="delete-icon"
                                        onClick={() => handleFileDelete(index)}
                                    >
                                        <i className="fa fa-trash" /> Remove
                                    </span>
                                </p>
                            </li>
                        );
                    }

                    return (
                        <li key={index} className="file-item">
                            <span>
                                <i className="fa fa-file-o" /> {file.name}
                            </span>

                            <p className="file-name-delete">
                                <span className="file-name">{file.name}</span>
                                <span className="delete-icon" onClick={() => handleFileDelete(index)}                                >
                                    <i className="fa fa-trash" /> Remove
                                </span>
                            </p>
                        </li>
                    );
                })}
        </ul>
    )
}

export default DocumentPreview
